<!-- BaseTimeInput.vue (common) -->
<template tag="시간 입력 컴포넌트">
  <Base.Select
    :items="timeArr"
    append-inner-icon="mdi-clock-time-eight-outline"
    placeholder="00:00"
    class="flex-0-0"
    :disabled="disabled"
    v-model="model"
    style="width: 150px"
    :isAuto="false"
  ></Base.Select>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Base } from "@/common/base-components/BaseFactory.ts";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel({ type: String });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  disabled: { type: Boolean },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
const timeArr = ref<string[]>([]);
for (let hours = 0; hours < 24; hours++) {
  for (let minutes = 0; minutes < 60; minutes += 30) {
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    timeArr.value.push(`${formattedHours}:${formattedMinutes}`);
  }
}
</script>
